import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function joinWaitlist({ country_code, phone, referral_source }) {
  const { data } = await api.post("/waitlist", {
    country_code,
    phone,
    referral_source,
  });
  return data;
}

export async function getWaitlistCount() {
  const { data } = await api.get("/waitlist/count");
  return data.count;
}

export async function createSignup(payload) {
  const { data } = await api.post("/signup", payload);
  return data;
}
